import { useState, useEffect } from "react";
import {
    Card,
    Grid,
    Box,
    Typography,
    Fade,
    Button
} from "@mui/material";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "examples/Tables/DataTable";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import * as XLSX from "xlsx";

// Function to handle PDF Download
const downloadPDF = () => {
    const { columns, rows } = authorsTableData();
    const doc = new jsPDF();

    doc.text("लोकशाही दिन अहवाल", 14, 10); // Title
    autoTable(doc, {
        head: [columns.map(col => col.Header)],
        body: rows.map(row => columns.map(col => row[col.accessor])),
        startY: 20,
        theme: "grid",
    });

    doc.save("Lokshahi_Report.pdf");
};

// Function to handle Excel Download
const downloadExcel = () => {
    const { columns, rows } = authorsTableData();
    const worksheetData = [columns.map(col => col.Header)]; // Headers

    rows.forEach(row => {
        worksheetData.push(columns.map(col => row[col.accessor])); // Row data
    });

    const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "नैसर्गिक आपत्ती मुळे मयत जनावरांचा तपशिल");
    XLSX.writeFile(workbook, "Report.xlsx");
};

// Table Data Function with Official Data
function authorsTableData() {
    return {
        columns: [
            { Header: "Sr No", accessor: "srNo", align: "center", sx: { fontSize: "20px", fontWeight: "bold" } },
            { Header: "तालुका", accessor: "taluka", align: "left", sx: { fontSize: "20px", fontWeight: "bold" } },
            { Header: "मयत झालेल्या जनावरांची संख्या", accessor: "deadAnimals", align: "center", sx: { fontSize: "20px", fontWeight: "bold" } },
            { Header: "PM झालेल्या जनावरांची संख्या", accessor: "pmAnimals", align: "center", sx: { fontSize: "20px", fontWeight: "bold" } },
            { Header: "बिल तयार झालेली संख्या", accessor: "billPrepared", align: "center", sx: { fontSize: "20px", fontWeight: "bold" } },
            { Header: "कोषागारामध्ये दाखल बिलाची संख्या", accessor: "billSubmitted", align: "center", sx: { fontSize: "20px", fontWeight: "bold" } },
            { Header: "रजिस्ट्रेशन झालेली संख्या", accessor: "registered", align: "center", sx: { fontSize: "20px", fontWeight: "bold" } },
            { Header: "प्रलंबित", accessor: "pending", align: "center", sx: { fontSize: "20px", fontWeight: "bold" } },
            { Header: "पशुधन मालकास निधी वितरण संख्या", accessor: "fundDistributed", align: "center", sx: { fontSize: "20px", fontWeight: "bold" } },
            { Header: "शेरा", accessor: "remarks", align: "center", sx: { fontSize: "20px", fontWeight: "bold" } },
        ],

        rows: [
            { srNo: "1", taluka: "छत्रपती संभाजीनगर", deadAnimals: "5", pmAnimals: "3", billPrepared: "2", billSubmitted: "1", registered: "4", pending: "1", fundDistributed: "2", remarks: "Approved" },
            { srNo: "2", taluka: "सिल्लोड", deadAnimals: "10", pmAnimals: "8", billPrepared: "6", billSubmitted: "5", registered: "9", pending: "2", fundDistributed: "5", remarks: "Processing" },
            { srNo: "3", taluka: "सोयगाव", deadAnimals: "7", pmAnimals: "5", billPrepared: "4", billSubmitted: "3", registered: "6", pending: "1", fundDistributed: "3", remarks: "Completed" },
            { srNo: "4", taluka: "कन्नड", deadAnimals: "15", pmAnimals: "10", billPrepared: "8", billSubmitted: "7", registered: "12", pending: "3", fundDistributed: "7", remarks: "Processing" },
            { srNo: "5", taluka: "फुलंब्री", deadAnimals: "12", pmAnimals: "9", billPrepared: "7", billSubmitted: "6", registered: "11", pending: "2", fundDistributed: "6", remarks: "Pending" },
            { srNo: "6", taluka: "गंगापूर", deadAnimals: "8", pmAnimals: "6", billPrepared: "5", billSubmitted: "4", registered: "7", pending: "1", fundDistributed: "4", remarks: "Completed" },
            { srNo: "7", taluka: "वैजापूर", deadAnimals: "14", pmAnimals: "11", billPrepared: "9", billSubmitted: "8", registered: "13", pending: "3", fundDistributed: "8", remarks: "Processing" },
            { srNo: "8", taluka: "पैठण", deadAnimals: "9", pmAnimals: "7", billPrepared: "6", billSubmitted: "5", registered: "8", pending: "1", fundDistributed: "5", remarks: "Approved" },
            { srNo: "9", taluka: "खुलताबाद", deadAnimals: "11", pmAnimals: "8", billPrepared: "7", billSubmitted: "6", registered: "10", pending: "2", fundDistributed: "6", remarks: "Pending" },
        ],
    };
}

export default function StaticTable() {
    const { columns, rows } = authorsTableData();

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <Box mt={5} mb={3}>
                <Grid item xs={12}>
                    <Card>
                        <MDBox
                            mx={2}
                            mt={-3}
                            py={3}
                            px={2}
                            variant="gradient"
                            bgColor="info"
                            borderRadius="lg"
                            coloredShadow="info"
                            display="flex"
                            justifyContent="space-between"
                            alignItems="center"
                        >
                            <MDTypography variant="h4" color="white">
                                नैसर्गिक आपत्ती मुळे मयत जनावरांचा तपशिल
                            </MDTypography>
                            <Box mt={2}>
                                <Button
                                    variant="contained"
                                    onClick={downloadPDF}
                                    sx={{
                                        mr: 1,
                                        backgroundColor: "#fff",
                                        boxShadow: "none",
                                        color: "#1976d2",
                                        '&:hover': { backgroundColor: "#fff", boxShadow: "none" }
                                    }}
                                    startIcon={<PictureAsPdfIcon />}
                                >
                                    Download PDF
                                </Button>
                                <Button
                                    variant="contained"
                                    onClick={downloadExcel}
                                    sx={{
                                        backgroundColor: "#fff",
                                        boxShadow: "none",
                                        color: "#388e3c",
                                        '&:hover': { backgroundColor: "#fff", boxShadow: "none" }
                                    }}
                                    startIcon={<InsertDriveFileIcon />}
                                >
                                    Download Excel
                                </Button>
                            </Box>
                        </MDBox>
                        <MDBox pt={3}>
                            <DataTable
                                table={{ columns, rows }}
                                isSorted={false}
                                entriesPerPage={false}
                                showTotalEntries={false}
                                noEndBorder
                            />
                        </MDBox>
                    </Card>
                </Grid>
            </Box>
        </DashboardLayout>
    );
}